import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../../services/apiAxios';
import helpers from '../../../mixins/helpers';

const state = {
    indicadorPresupuestosPropuestos: {},
    indicadorPresupuestosConfirmadosPropuestos: {},
};

const mutations = {
    updateField,

    'INICIALIZAR_INDICADOR_PRESUPUESTOS_PROPUESTOS' (state) {
        state.indicadorPresupuestosPropuestos = {};
    },
    'SET_INDICADOR_PRESUPUESTOS_PROPUESTOS'(state, indicador) {
        state.indicadorPresupuestosPropuestos = indicador;
    },
    'INICIALIZAR_INDICADOR_PRESUPUESTOS_CONFIRMADOS_PROPUESTOS' (state) {
        state.indicadorPresupuestosConfirmadosPropuestos = {};
    },
    'SET_INDICADOR_PRESUPUESTOS_CONFIRMADOS_PROPUESTOS'(state, indicador) {
        state.indicadorPresupuestosConfirmadosPropuestos = indicador;
    },
};

const getters = {
    getField,

    indicadorPresupuestosPropuestos(state) {
        return state.indicadorPresupuestosPropuestos;
    },
    indicadorPresupuestosConfirmadosPropuestos(state) {
        return state.indicadorPresupuestosConfirmadosPropuestos;
    },
};

const actions = {
    getIndicadorPresupuestosPropuestos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_PRESUPUESTOS_PROPUESTOS');

            apiAxios.get('indicadores/presupuestos/propuestos')
                .then(res => {
                    commit('SET_INDICADOR_PRESUPUESTOS_PROPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getIndicadorPresupuestosConfirmadosPropuestos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_INDICADOR_PRESUPUESTOS_CONFIRMADOS_PROPUESTOS');

            apiAxios.get('indicadores/presupuestos/propuestos/confirmados')
                .then(res => {
                    commit('SET_INDICADOR_PRESUPUESTOS_CONFIRMADOS_PROPUESTOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}